<template>
  <a-modal
      title="图文消息列表"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submit"
      @cancel="visible = false"
      :afterClose="afterClose"
  >
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="Activity name">
        <a-input :size="$globalSize" v-model="form.name"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import utils from "@/utils";

export default {
  name: "graphicMessageModal",
  components: {},
  props: {},

  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 7
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 17
      },
      form: {}
    };
  },
  mounted() {
    utils.languageChange(this, {labelCol: 8, wrapperCol: 16}, {labelCol: 6, wrapperCol: 16})
  },
  computed: {},
  watch: {},
  methods: {
    showModal() {
      this.visible = true;
    },
    submit(record) {
      this.$emit('sync',record)
    },
    afterClose() {
    }
  },
};
</script>

<style scoped lang="less">

</style>
